import { DropdownMenu, DropdownMenuTrigger } from "../../../../atom/Dropdown/Dropdown";
import { ArrowDownIcon } from "../../../../../icons";
import MyCalendarDropdownContent from "../../MyCalendarDropdownContent";
import { useEffect, useState } from "react";
import clsx from "clsx";
import CalendarColorBadge from "../../../../atom/Calendar/CalendarColorBadge";
import { useUpdateUserCalendarMutation } from "../../../../../react-query/userCalendars/mutations";
import { UserCalendarAccessType } from "../../../../../types/userCalendars/enum";
import { useFetchUserCalendarsQuery } from "../../../../../react-query/userCalendars/queries";

const PrimaryCalendar = () => {
  const [calendarSelectDropdownOpen, setCalendarSelectDropdownOpen] = useState<boolean>(false);
  const { mutate: updateUserPrimaryCalendar } = useUpdateUserCalendarMutation();
  const { data: editableUserCalendarList } = useFetchUserCalendarsQuery({
    calendarAccessType: UserCalendarAccessType.EDITABLE,
  });
  const [selectedCalendarId, setSelectedCalendarId] = useState<string | undefined>(undefined);
  const defaultPrimaryCalendar =
    editableUserCalendarList?.find((cal) => cal.primary)?.id.toString() ?? "";

  useEffect(() => {
    setSelectedCalendarId(defaultPrimaryCalendar);
  }, [defaultPrimaryCalendar]);

  const handleSelectCalendar = (stringifiedId: string) => {
    setSelectedCalendarId(stringifiedId);
    updateUserPrimaryCalendar({
      id: Number(stringifiedId),
      data: { primary: true },
    });
  };

  const handleOpenChange = (isOpen: boolean) => {
    setCalendarSelectDropdownOpen(isOpen);
  };

  return (
    <div
      className="flex p-5 items-center gap-[15px] self-stretch bg-[#313435] text-white justify-between rounded-[7px]"
      onClick={(e) => e.stopPropagation()}
    >
      <p className="text-body1">Primary Calendar</p>
      <DropdownMenu
        open={calendarSelectDropdownOpen}
        onOpenChange={handleOpenChange}
      >
        <DropdownMenuTrigger asChild>
          <button
            className={clsx(
              "inline-flex align-center px-[10px] py-[8px] gap-[6px] items-center cursor-pointer text-body1 rounded-[5px]",
              {
                "bg-[rgba(255,255,255,0.08)]": calendarSelectDropdownOpen,
                "bg-transparent hover:bg-[rgba(255,255,255,0.08)]": !calendarSelectDropdownOpen,
              }
            )}
            onClick={() => handleOpenChange(!calendarSelectDropdownOpen)}
          >
            <CalendarColorBadge
              color={
                editableUserCalendarList?.find((cal) => cal.id.toString() === selectedCalendarId)
                  ?.backgroundColor ?? "#E7BA51"
              }
            />
            <div className="flex text-[14px] leading-[100%]">
              {editableUserCalendarList?.find((cal) => cal.id.toString() === selectedCalendarId)
                ?.name ?? "No title"}
            </div>
            <ArrowDownIcon className="w-[16px] h-[16px] flex-shrink-0" />
          </button>
        </DropdownMenuTrigger>
        <MyCalendarDropdownContent
          calendarList={editableUserCalendarList ?? []}
          onSelect={handleSelectCalendar}
          selectedValue={selectedCalendarId}
        />
      </DropdownMenu>
    </div>
  );
};

export default PrimaryCalendar;
